import { TooltipHost } from '@fluentui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Number from '../../components/Number/Number';

const MarketCard = (props) => {

    const navigate = useNavigate();

    const onNav = () => {
        if (!props?.disable) {
            navigate('/hrsuite/market/' + props.id);
        }
    }

    return (
        <div style={{ width: 200, height: 300, border: '1px solid #B4B4B4', borderRadius: 8, display: 'flex', flexDirection: 'column', marginRight: 16 }} className='marketCard' onClick={onNav}>
            {props?.disable && (
                <div style={{ position: 'absolute', display: 'flex', width: 200, justifyContent: 'flex-end' }}>
                    <div style={{ color: '#FFFFFF', fontSize: 12, background: '#EC0000', padding: '5px 12px', borderTopRightRadius: 8, borderBottomLeftRadius: 8 }}>
                        Тун удахгүй
                    </div>
                </div>
            )}
            <div style={{ flex: 1 }}>
                <div style={{ height: 140, width: 200, borderTopLeftRadius: 7, borderTopRightRadius: 7, overflow: 'hidden' }}>
                    <img src={props.imageUrl} alt='' style={{ width: '100%', height: '100%' }} />
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, margin: 12 }}>
                    {props.title?.length > 18 ?
                        (<TooltipHost content={props.title} > {(props.title?.substring(0, 18) + "...")}</TooltipHost>) : props.title}
                </div>
                <div style={{ fontSize: 12, fontWeight: 400, paddingLeft: 12, paddingRight: 12, marginTop: 6, marginBottom: 6 }}>
                    {props.description?.length > 60 ? (<TooltipHost content={props.description} > {(props.description?.substring(0, 60) + "...")}</TooltipHost>) : props.description}
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 12, marginBottom: 8 }}>
                <div style={{ backgroundColor: props?.disable ? '#E4E4E4' : '#3E2FA0', borderRadius: 3, padding: 5, color: '#FFFFFF', fontSize: 14, display: 'flex', alignItems: 'center' }}>
                    <Number symbol textAlign='left' value={props.price} />
                    <div>{props?.hidepricetype ? null : " / сар"}</div>
                </div>
            </div>
        </div >
    );
}

export default MarketCard;